import React, { Component } from 'react';

class LanguageList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      languages, noInfoMessage
    } = this.props;
    if (!languages || !Array.isArray(languages) || languages.length === 0) {
      return (
        <span>
          {noInfoMessage}
        </span>
      );
    }

    return languages.map(language => (
      <span
        key={language.key}
        className='br-chip'
      >{language.name || language.nativeName || language.englishName}</span>
    ));
  }
}

export default LanguageList;
